import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = ({ onOpenForm }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);

    // Apply theme
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <Link to="/" className="logo">
            <div className="logo-badge">
              <svg viewBox="0 0 12 12"><polygon points="6,1 11,9 1,9" /></svg>
            </div>
            AMAVIX TECH
          </Link>

          <ul className="nav-links">
            <li><NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink></li>
            <li><NavLink to="/services" className={({ isActive }) => isActive ? 'active' : ''}>Services</NavLink></li>
            <li><NavLink to="/projects" className={({ isActive }) => isActive ? 'active' : ''}>Projects</NavLink></li>
            <li><NavLink to="/process" className={({ isActive }) => isActive ? 'active' : ''}>Process</NavLink></li>
            <li><NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''}>About</NavLink></li>
            <li><NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''}>Contact</NavLink></li>
          </ul>

          <div className="nav-right">
            <button className="nav-btn" onClick={onOpenForm}>Start Project</button>
            <button className="theme-toggle" onClick={toggleTheme} aria-label="Toggle Theme">
              <div className={`toggle-track ${theme === 'dark' ? 'active' : ''}`}>
                <div className="toggle-thumb">
                  {theme === 'light' ? '☀️' : '🌙'}
                </div>
              </div>
            </button>
          </div>

          <button className={`nav-burger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <span></span><span></span><span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <ul className="mm-links">
          <li><NavLink to="/" end onClick={toggleMenu}>Home</NavLink></li>
          <li><NavLink to="/services" onClick={toggleMenu}>Services</NavLink></li>
          <li><NavLink to="/projects" onClick={toggleMenu}>Projects</NavLink></li>
          <li><NavLink to="/process" onClick={toggleMenu}>Process</NavLink></li>
          <li><NavLink to="/about" onClick={toggleMenu}>About</NavLink></li>
          <li><NavLink to="/contact" onClick={toggleMenu}>Contact</NavLink></li>
        </ul>
        <div className="mm-bottom">
          <button className="mm-cta" onClick={onOpenForm}>Start a Project</button>
          <button className="theme-toggle" onClick={toggleTheme}>
            <div className={`toggle-track ${theme === 'dark' ? 'active' : ''}`}>
              <div className="toggle-thumb">
                {theme === 'light' ? '☀️' : '🌙'}
              </div>
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default Navbar;
